import { c as _c } from "react/compiler-runtime";
import { VerticalDotsMenu } from "@components/action-buttons/vertical-dots-menu";
import { DeleteIcon, IconButtonSizes, ArchiveIcon, UnarchiveIcon, DownloadIcon } from "@flat-ui";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { ShareProjectOption } from "@pages/projects/share-project-option";
import { useState } from "react";
import { PALETTE_VARS } from "@styles/palette-vars";

/**
 *  Provides actions buttons for project details page in a compact version.
 */
export function ResponsiveProjectButtons(t0) {
  const $ = _c(26);
  const {
    project
  } = t0;
  const [shouldShowDeleteDialog, setShouldShowDeleteDialog] = useState(false);
  const {
    archiveOrUnarchiveProject,
    canDeleteProject,
    archiveActionLabel,
    isProjectActive,
    canDownloadFromVault,
    openInSphereVault
  } = useProjectActions(project);
  const t1 = isProjectActive ? ArchiveIcon : UnarchiveIcon;
  let t2;
  if ($[0] !== archiveActionLabel || $[1] !== archiveOrUnarchiveProject || $[2] !== t1) {
    t2 = {
      label: archiveActionLabel,
      Icon: t1,
      onClick: archiveOrUnarchiveProject,
      isVisible: true
    };
    $[0] = archiveActionLabel;
    $[1] = archiveOrUnarchiveProject;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== canDownloadFromVault || $[5] !== openInSphereVault) {
    t3 = {
      label: "Download from Sphere Vault",
      Icon: DownloadIcon,
      onClick: openInSphereVault,
      isVisible: canDownloadFromVault
    };
    $[4] = canDownloadFromVault;
    $[5] = openInSphereVault;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== project) {
    t4 = {
      label: "Share",
      component: <ShareProjectOption project={project} />,
      isVisible: true
    };
    $[7] = project;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = !isProjectActive && canDeleteProject;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      type: "separator",
      isVisible: t5,
      label: ""
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setShouldShowDeleteDialog(true);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = !isProjectActive && canDeleteProject;
  let t9;
  if ($[12] !== t8) {
    t9 = {
      label: "Delete",
      Icon: DeleteIcon,
      onClick: t7,
      color: "error.main",
      highlightColor: PALETTE_VARS.error.main,
      isVisible: t8
    };
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t9) {
    const menuItems = [t2, t3, t4, t6, t9];
    t10 = <VerticalDotsMenu menuItems={menuItems} size={IconButtonSizes.m} />;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== project || $[21] !== shouldShowDeleteDialog) {
    t11 = shouldShowDeleteDialog && <DeleteProject project={project} onClose={() => setShouldShowDeleteDialog(false)} />;
    $[20] = project;
    $[21] = shouldShowDeleteDialog;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}